import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { Icon, ShareDirective } from '@malirang/front-share';

@Component({
  selector: 'app-content-share',
  template: `
    <app-icon
      share
      [title]="title()"
      name="majesticons:share"
      class="text-gray-400"
    />
  `,
  imports: [Icon, CommonModule, ShareDirective],
})
export class ContentShareComponent {
  title = input.required<string>();
}
